import { prettifyJson } from "../../../shared/json";

const files = [
  "./charge_key.json",
  "./creation.json",
  "./modification.json",
  "./specific.post.json",
  "./specific.trigger_recreation.json",
  "./checkbox.json",
  "./radio.json",
  "./select.json",
  "./toggle.json",
  "./divided_input.json",
  "./editable_card.json",
  "./time_picker.json",
  "./time_range_picker.json",
  "./date_picker.json",
  "./date_range_picker.json",
  "./input_with_unit.json",
  "./authorized_week_days.json",
  "./sub_structure_selector.json",
];

const sanitize = (key: string): string => {
  const cleaned = key.replace("./", "");

  return cleaned[0]?.toUpperCase() + cleaned.slice(1) || "";
};

export const getTemplates = async (): Promise<Map<string, string>> => {
  const templates = new Map<string, any>();

  for (const file of files) {
    const module = await import(file);
    const content = module.default;
    templates.set(sanitize(file), prettifyJson(content));
  }

  return templates;
};
